import { connect } from 'react-redux';
import { getProject } from 'project/ducks/project';
import { canAward } from 'entries/utils';
import { getAwards, toggleAward } from 'entries/ducks';
import { getAwarded } from 'project/ducks/creatives';
import AwardButton from 'entries/components/award_button';

const mapStateToProps = (state, { entry }) => {
  const user = state.user.profile_data;
  const project = getProject(state);
  const awardedCreatives = getAwarded(state, true);

  return {
    canAward: canAward({ user, entry, project, awardedCreatives }),
    award: getAwards(state, true)[0]
  };
}

export default connect(mapStateToProps, {
  toggleConfirmation: toggleAward
})(AwardButton);



// WEBPACK FOOTER //
// ./entries/containers/award_button.js